export default __webpack_public_path__ + "static/media/1.f37941b3.png";